import { render, staticRenderFns } from "./DataButton.vue?vue&type=template&id=693c2ff6"
import script from "./DataButton.vue?vue&type=script&lang=js"
export * from "./DataButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports